import { render, staticRenderFns } from "./ManagerShiftEditorGeneral.vue?vue&type=template&id=690460ce&lang=pug&"
import script from "./ManagerShiftEditorGeneral.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftEditorGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports